import { Routes } from "./routes/index";
import "./App.css";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const location = useLocation();
  const tokenExpiration = useSelector(
    (state) => state.expirationReducer.tokenExpiration,
  );
  const isAuthorized = useSelector(
    (state) => state.isAuthorizedReducer.isAuthorized,
  );

  useEffect(() => {
    if (tokenExpiration) {
      setTimeout(() => {
        axiosInstance.logout();
        window.location.href = "";
      }, tokenExpiration);
    }
  }, [tokenExpiration]);

  // Track page views for React Router (only on drospect.ai, no subdomains)
  useEffect(() => {
    if (
      typeof window.gtag === "function" &&
      (window.location.hostname === "drospect.ai" ||
        window.location.hostname === "www.drospect.ai")
    ) {
      window.gtag("config", "G-HW9T0GVJWZ", {
        page_path: location.pathname + location.search + location.hash,
        page_title: document.title,
        send_page_view: true,
      });
    }
  }, [location]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes isAuthorized={isAuthorized} />
    </>
  );
}

export default App;
